import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import {
  shouldShowProductionRange,
  getAnnualProductionRange,
} from "../PropView/helper-functions";

// Graph config options
const blue = "rgba(65,126,238,1)";
const gray = "rgba(196, 196, 196, 0.927)";
const primaryYellow = "rgba(252,236,44,1)";
const secondaryYellow = "rgba(252, 236, 44, 0.4)";
const primaryGray = "rgba(196, 196, 196, 0.927)";
const secondaryGray = "rgba(196, 196, 196, 0.3)";
const fontFamily = "Lexend";

// Generates line dataset
const generateLineDataset = (label, data, primaryColor, secondaryColor) => {
  return {
    label: label,
    font: {
      size: 35,
      family: fontFamily,
    },
    datalabels: {
      display: false,
    },
    type: "line",
    data: data,
    fill: true,
    pointBackgroundColor: primaryColor,
    borderColor: primaryColor,
    backgroundColor: secondaryColor,
    pointBorderWidth: "150px",
    pointStyle: "circle",
    pointRadius: 6,
    hoverRadius: 6,
  };
};

const ProdChart = (props) => {
  const [displayUsage, setDisplayUsage] = useState("");
  const [displayProduction, setDisplayProduction] = useState([]);
  const { usage, production, currentUsage, width, smallBreakPoint, salesTeam } =
    props;

  // Set display usage and production
  useEffect(() => {
    setDisplayUsage(usage);

    if (shouldShowProductionRange(salesTeam)) {
      const [low, high] = getAnnualProductionRange(production, salesTeam);

      setDisplayProduction([
        generateLineDataset(
          "Low Production",
          low,
          primaryYellow,
          secondaryYellow
        ),
        generateLineDataset(
          "High Production",
          high,
          primaryGray,
          secondaryGray
        ),
      ]);
    } else {
      setDisplayProduction([
        generateLineDataset(
          "Production",
          production,
          primaryYellow,
          secondaryYellow
        ),
      ]);
    }
  }, [props]);

  return (
    <div>
      <Bar
        data={{
          labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
          ],
          datasets: [
            // Line charts
            ...displayProduction,
            // Bar charts
            {
              barThickness: width > smallBreakPoint ? 36 : 15,
              label: "Usage",
              datalabels: {
                display: false,
              },
              type: "bar",
              backgroundColor: currentUsage?.map((u) =>
                props.uType === "Partial 12 Months"
                  ? u > 0
                    ? blue
                    : gray
                  : blue
              ),
              data: displayUsage && displayUsage?.map((u) => Math.round(u)),
            },
          ],
        }}
        options={{
          tooltips: {
            bodyFontFamily: fontFamily,
            bodyFontStyle: "300",
            boxShadow: "0px 0px 8px 2px rgba(0,0,0,0.12)",
            titleFontSize: false,
            bodyFontSize: 20,
            displayColors: false,
            backgroundColor: "rgb(172,172,172)",
            footerFontColor: "rgba(248,47,43,1)",
            hoverRadius: 6,
            callbacks: {
              title: function () {},
              label: function (context) {
                return (
                  Math.round(context.value).toLocaleString(undefined) + " kWh"
                );
              },
              labelTextColor: function (context) {
                if (context.datasetIndex === 0) {
                  return "rgba(252,236,44,1)";
                }
                return "rgb(65,126,238)";
              },
            },
            yAlign: "bottom",
            xAlign: "center",
          },
          title: {
            display: true,
            text: "",
            fontSize: 25,
            fontColor: "#000",
          },
          legend: {
            display: false,
            position: "bottom",
            labels: { fontColor: "#000" },
          },
          scales: {
            xAxes: [
              {
                ticks: {
                  fontFamily: fontFamily,
                  fontSize: width > smallBreakPoint ? 18 : 10,
                  fontStyle: "200",
                  padding: 10,
                },
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                  drawBorder: false,
                  zeroLineColor: "transparent",
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  fontFamily: fontFamily,
                  fontSize: width > smallBreakPoint ? 18 : 10,
                  fontStyle: "200",
                  padding: 10,
                  beginAtZero: true,
                  callback: function (value) {
                    return value.toLocaleString(undefined);
                  },
                },
                gridLines: {
                  borderDash: [7, 6],
                  color: "rgba(209, 209, 209, 1)",
                  drawBorder: false,
                  // zeroLineColor: 'transparent'
                },
              },
            ],
          },
        }}
        height={width > smallBreakPoint ? 120 : 225}
      />
    </div>
  );
};

export default ProdChart;
